import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";
import { useAppStore } from "@/store";
import { ZIndex } from "@/domains/design/constants";
import { SidebarContents } from "@/components/layout/components/sidebar/sidebar-contents";
import { useState } from "react";
import { SidebarAccountInfo } from "@/components/layout/components/sidebar/sidebar-account-info";
import { SidebarDropdownMenu } from "@/components/layout/components/sidebar/sidebar-dropdown-menu";
import { css } from "@/domains/emotion";
import { motion } from "motion/react";
import { TOP_BAR_HEIGHT } from "@/components/layout/components/constants";
import { MDSIconButton, MDSIconKind } from "@/mds";

interface SidebarMobileProps {
  onClick: () => void;
  setIsImportModalOpen: (b: boolean) => void;
}

export const SidebarMobile = observer(({ onClick, setIsImportModalOpen }: SidebarMobileProps) => {
  const { store } = useAppStore();
  const { profileDisplayName, profilePhotoUrl, profileEmailAddress } = store.account.myAccount;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Wrapper
      initial={{ opacity: 0, scale: 0.97 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.12, ease: "easeInOut" }}
    >
      <ContainerTop>
        {isMenuOpen && (
          <MDSIconButton iconKind={MDSIconKind.LeftArrow} onClick={() => setIsMenuOpen(false)} />
        )}
        <SidebarAccountInfo
          profileSize={34}
          profileDisplayName={profileDisplayName}
          profilePhotoUrl={profilePhotoUrl}
          profileEmailAddress={profileEmailAddress}
        />
        {!isMenuOpen && (
          <MDSIconButton
            iconKind={MDSIconKind.AngleRight}
            onClick={() => setIsMenuOpen(true)}
            className={alignRightStyles}
          />
        )}
      </ContainerTop>
      {isMenuOpen ? (
        <StyledSidebarDropdownMenu
          className={dropdownStyles}
          onClick={onClick}
          setIsImportModalOpen={setIsImportModalOpen}
        />
      ) : (
        <SidebarContentsWrapper>
          <SidebarContents onClick={onClick} />
        </SidebarContentsWrapper>
      )}
    </Wrapper>
  );
});

const Wrapper = styled(motion.div)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: theme.spacing["1"],
  backgroundColor: theme.colors.surface.menu,
  height: `calc(100dvh - ${TOP_BAR_HEIGHT}px)`,
  width: "calc(100dvw)",
  position: "absolute",
  top: `calc(${TOP_BAR_HEIGHT}px)`,
  borderTopLeftRadius: theme.borderRadius.large,
  zIndex: ZIndex.Sidebar,
}));

const ContainerTop = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  padding: theme.spacing["4"],
  gap: theme.spacing["1"],
  borderBottom: `1px solid ${theme.colors.border.default}`,
}));

const SidebarContentsWrapper = styled.div(({ theme }) => ({
  overflowY: "scroll",
  padding: theme.spacing["2"],
}));

const dropdownStyles = css({
  backgroundColor: `transparent`,
  boxShadow: `none`,
  width: `100%`,
  border: 0,
  height: "auto",
});

const alignRightStyles = css({
  marginLeft: "auto",
});

const StyledSidebarDropdownMenu = styled(SidebarDropdownMenu)`
  max-width: unset;
  width: 100%;
`;
